//Loads only those fees for the current logged in portal user
define(function() {
	const IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
		parse: function(response) {
			return response;
		}
	});
});
